













import { Prop, Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import UpfrontContributionBase from "@/employee/components/onboarding/upfront-contribution/UpfrontContributionBase.vue";
import ConfirmContributionPage from "@/shared/components/contributionsV3/ConfirmContributionPage.vue";
import { OnboardingBalanceTransfer } from "@/employee/route-names";
import { TransferSchedule } from "@/shared/types";

@Component({
  components: {
    Button,
    UpfrontContributionBase,
    ConfirmContributionPage
  }
})
export default class OnboardingConfirmContributionPage extends Vue {
  @Prop()
  schedule: TransferSchedule;

  @Prop()
  page: number;

  @Prop()
  updating: boolean;

  @Prop()
  routeToModifySchedule: (schedule: TransferSchedule) => Location;

  onSkip () {
    this.$router.push({
      name: OnboardingBalanceTransfer
    });
  }
}
